'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { MAX_SIMULTANEOUS_ACCOUNTS } from 'AdsUI/lib/Constants';
import AdAccountSelect from 'AdsUI/components/AdAccountSelect';
import { changeFilters } from 'AdsUI/actions/GlobalFilterActions';
import { getAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
import { getConnectedUsers } from 'AdsUI/selectors/AccountsSelectors';
import { getSelectedAdAccounts, getAdAccountsByUserAndTeams } from 'AdsUI/selectors/GlobalFilters';
import { hasUnlimitedAdAccounts, hasUsersAndTeams } from 'AdsUI/selectors/AuthSelectors';

const GlobalAdAccountFilterContainer = (_ref) => {
  let {
    adAccounts,
    adAccountsByUserAndTeams,
    connectedUsers,
    selectedAdAccounts,
    unlimitedAdAccounts,
    hasAccessToUsersAndTeams,
    disablePaymentMissingAccount
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["adAccounts", "adAccountsByUserAndTeams", "connectedUsers", "selectedAdAccounts", "unlimitedAdAccounts", "hasAccessToUsersAndTeams", "disablePaymentMissingAccount"]);

  const maxAccounts = unlimitedAdAccounts ? undefined : MAX_SIMULTANEOUS_ACCOUNTS;
  return /*#__PURE__*/_jsx(AdAccountSelect, {
    adAccounts: hasAccessToUsersAndTeams ? adAccountsByUserAndTeams : adAccounts,
    connectedUsers: connectedUsers,
    accountFilter: selectedAdAccounts,
    onFilterChange: changedAdAccounts => props.changeFilters({
      adAccounts: changedAdAccounts
    }),
    maxAccounts: maxAccounts,
    disablePaymentMissingAccount: disablePaymentMissingAccount
  });
};

function mapStateToProps(state) {
  return {
    adAccounts: getAdAccounts(state),
    adAccountsByUserAndTeams: getAdAccountsByUserAndTeams(state),
    connectedUsers: getConnectedUsers(state),
    selectedAdAccounts: getSelectedAdAccounts(state),
    unlimitedAdAccounts: hasUnlimitedAdAccounts(state),
    hasAccessToUsersAndTeams: hasUsersAndTeams(state)
  };
}

const mapDispatchToProps = {
  changeFilters
};
export default connect(mapStateToProps, mapDispatchToProps)(GlobalAdAccountFilterContainer);